// NPM Imports
import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Props Declarations
const propTypes = {
  list: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  showStatus: PropTypes.bool,
};

const defaultProps = {
  list: {},
  showStatus: true,
};

export default function PriceListCard(props) {
  const {
    list: { active, currency, desc, name },
    showStatus = true,
  } = props;
  return (
    <div data-test="pricelistcard-wrapper" className="pricelistcard-wrapper">
      <div data-test="pricelistcard-section" className="pricelistcard-section">
        <div
          data-test="pricelistcard-txt-section"
          className="pricelistcard-txt-section">
          <div data-test="pricelistcard-icon" className="pricelistcard-icon">
            <div
              data-test="pricelistcard-section"
              className="pricelistcard-section">
              <span
                data-test="pricelistcard-currency"
                className={`pricelistcard-currency ${
                  active ? "plcard-crrncy-active" : "plcard-crrncy-inactive"
                }`}>
                {currency}
              </span>
            </div>
            <i>
              <FontAwesomeIcon icon={["fad", "book-spells"]} />
            </i>
          </div>
          <div
            data-test="pricelistcard-title-section"
            className="pricelistcard-title-section">
            <span
              data-test="pricelistcard-title"
              className="pricelistcard-title">
              {name}
            </span>
            <span
              data-test="pricelistcard-description"
              className="pricelistcard-description">
              {desc}
            </span>
            {showStatus && (
              <span className="pricelistcard-active">
                <span className="pricelistcard-active-status">
                  {active ? "Active" : "Inactive"}
                </span>
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

PriceListCard.defaultProps = defaultProps;
PriceListCard.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/Pricebook/PricebookList/PricelistCard.js